/**
 * Utility functions for handling dates in New Zealand timezone
 */

/**
 * Get current date in New Zealand timezone
 * @returns {Date} Current date in NZ timezone
 */
export const getCurrentNZDate = () => {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'Pacific/Auckland' }));
};

/**
 * Get the current month string in MMM-YY format based on NZ timezone
 * @returns {string} Month string in format like "Nov-25"
 */
export const getCurrentNZMonthString = () => {
  const nzDate = getCurrentNZDate();
  const monthAbbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][nzDate.getMonth()];
  const year = nzDate.getFullYear().toString().slice(-2);
  return `${monthAbbr}-${year}`;
};

/**
 * Check if a month string represents the current month in NZ timezone
 * @param {string} monthStr - Month string in MMM-YY format
 * @returns {boolean} True if the month is current in NZ timezone
 */
export const isCurrentNZMonth = (monthStr) => {
  if (!monthStr) return false;
  
  const nzDate = getCurrentNZDate();
  const currentMonth = nzDate.getMonth(); // 0-11
  const currentYear = nzDate.getFullYear();
  
  const [monthAbbr, yearStr] = monthStr.split('-');
  const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr);
  const year = 2000 + parseInt(yearStr, 10);
  
  return monthIndex === currentMonth && year === currentYear;
};

/**
 * Get the start and end dates of a month in NZ timezone
 * @param {string} monthStr - Month string in MMM-YY format
 * @returns {Object} Object with startDate and endDate
 */
export const getNZMonthDateRange = (monthStr) => {
  if (!monthStr) return null;
  
  const [monthAbbr, yearStr] = monthStr.split('-');
  const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr);
  const year = 2000 + parseInt(yearStr, 10);
  
  if (monthIndex === -1) return null;
  
  const startDate = new Date(year, monthIndex, 1);
  const endDate = new Date(year, monthIndex + 1, 0);
  
  return { startDate, endDate };
};